export const SPOUSE_VISA_SPONSOR_TYPE = "SPONSOR3";
export const DEFAULT_SIGNATORY_COUNTRY = "United Arab Emirates";
